import { PrevHeaderBarTemplate } from '#templates';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import ActivitiesQna from './qna';
import ActivitiesInformation from './information';
import { useUserInfo } from '#providers/UserInfo';
import { useQuery } from '@tanstack/react-query';
import { axios } from '#api/axios';

const ActivitiesList = () => {
  const { id } = useParams();
  const { userInfo } = useUserInfo();

  const { data: informationList } = useQuery({
    queryKey: ['get-information-community-coach-questions', userInfo?.id],
    queryFn: async () =>
      await axios.get<[]>(`/consumer/exercise/coach/questions/${userInfo?.id}`),
    enabled: !!userInfo?.id,
    select: data => data.data
  });

  const { data: qnaQuestions } = useQuery({
    queryKey: ['get-trainer-qna-questions', userInfo?.id],
    queryFn: async () =>
      await axios.get<
        {
          questionTitle: string;
          name: string;
          createdAt: Date;
          content: string;
          id: string;
        }[]
      >(`consumer/coach/questions/${userInfo?.id}`),
    select: data => data.data,
    enabled: !!userInfo?.id
  });

  return (
    <PrevHeaderBarTemplate prevRoute="../..">
      <div className="flex justify-around items-center border-b-1 border-solid border-[#7750e9]">
        {TAB_LIST.map(({ to, label, value }) => (
          <Link
            key={value}
            to={to}
            className={`${
              id === value ? 'border-[#7750e9]' : 'border-transparent'
            } py-12 border-0 border-b-[3px] border-solid w-full text-center`}
          >
            {`${label} ${
              value === 'information'
                ? informationList?.length && informationList.length
                : qnaQuestions?.length && qnaQuestions.length
            }`}
          </Link>
        ))}
      </div>
      <div className="overflow-auto">
        {id === 'information' ? (
          <ActivitiesInformation id={userInfo?.id} />
        ) : (
          <ActivitiesQna id={userInfo?.id} />
        )}
      </div>
    </PrevHeaderBarTemplate>
  );
};

export default ActivitiesList;

const TAB_LIST = [
  {
    to: '/profile/activities/qna',
    label: '질문 답변',
    value: 'qna'
  },
  {
    to: '/profile/activities/information',
    label: '운동 가이드',
    value: 'information'
  }
];
